import { Tag } from 'antd';
const defCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State defOption: Options = new Options({
    series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`


const changeCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
   @State defOption: Options = new Options({
      series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  aboutToAppear() {
    setTimeout(() => {
      // 使用Option实例对象的setVal方法来实现，修改什么属性就传什么
      this.defOption.setVal({
        series: [
          {
            name:'高气温',
            data: [
              {xVal: 30, yVal: 30, num: 17096869, name: '广州'},
              {xVal: 50, yVal: 50, num: 17096869, name: '上海'},
              {xVal: 12, yVal: 45, num: 17096869, name: '北京'},
              {xVal: 70, yVal: 36, num: 17096869, name: '深圳'}
            ]
          }
        ]
      })
    }, 2000)
  }
  build() {
    Row() {
      McPointChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`


const xAxisCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State xAxisOption: Options = new Options({
    xAxis:{
      axisLine: { // 轴线样式
        show: true, // 是否显示
        lineStyle: {
          color: '#ccc',
          width: 2
        }
      },
      axisTick: { // 刻度线配置
        show: true, // 是否显示
        interval: 6, // 与文本的间隔
        length: 4, // 刻度的长度
        lineStyle: {
          color: '#ccc', // 刻度线颜色
          width: 2 // 刻度线宽度
        }
      },
      axisLabel: {
        color: '#bf19ff',
        fontWeight: '600',
        fontFamily: 'sans-serif',
        fontSize: 24,
      }
    },
    series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.xAxisOption
      })
    }
    .height('50%')
  }
}
`

const yAxisCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State yAxisOption: Options = new Options({
    yAxis: {
      name: '单位/摄氏度', // 坐标名称
      nameTextStyle: {
        color: '#ccc',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 18,
      },
      axisLine: { // 轴线样式
        show: true, // 是否显示
        lineStyle: {
          color: '#ccc',
          width: 2
        }
      },
      axisTick: { // 刻度线配置
        show: true, // 是否显示
        interval: 4, // 与文本的间隔
        length: 5, // 刻度的长度
        lineStyle: {
          color: '#ccc', // 刻度线颜色
          width: 2 // 刻度线宽度
        }
      },
      splitLine: { // 坐标轴中的分隔线。
        show: true,
        lineStyle: {
          color: '#4f000000',
          width: 2
        }
      },
      axisLabel: {  // x轴文本标签样式
        color: '#bf19ff',
        fontWeight: '600',
        fontFamily: 'sans-serif',
        fontSize: 20,
      },
      formatter: function (name) { // 自定义文本标签
        return name + '°C'
      },
    },
    series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.yAxisOption
      })
    }
    .height('50%')
  }
}
`

const legendCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State legendOption: Options = new Options({
    legend: {
      show: true,
      left: '90%',
      top: '2%',
      itemGap: 10, // 图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。
      itemTextGap: 10, // 图例图例之间的间隔。
      itemWidth: 8, // 图例标记的图形宽度。
      itemHeight: 8, // 图例标记的图形高度。
      textStyle: {
        color: '#000',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 24
      }
    },
    series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const tooltipCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
    tooltip: {
      show: true,
      type: 'default', // 渲染类型。可选值：default（默认）、custom（自定义）
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#000',
          width: 2,
          type: 'solid'
        }
      },
      backgroundColor: '#97cccccc',
      borderColor: '#333',
      borderWidth: 1,
      padding: 10,
      textStyle: {
        color: '#000',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 18
      }
    },
    series:[
      {
        name:'高气温',
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.tooltipOption
      })
    }
    .height('50%')
  }
}
`

const seriesCode = `
import { McPointChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State seriesOption: Options = new Options({
    series:[
      {
        name:'高气温',
        color: '#ff2659f5',
        symbolSize: function (data) {
          return data.xVal
        },
        data: [
          {xVal: 40, yVal: 26, num: 17096869, name: '广州'},
          {xVal: 20, yVal: 30, num: 17096869, name: '上海'},
          {xVal: 30, yVal: 40, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 28, num: 17096869, name: '深圳'}
        ]
      },
      {
        name:'低气温',
        data: [
          {xVal: 40, yVal: 0, num: 17096869, name: '广州'},
          {xVal: 20, yVal: -10, num: 17096869, name: '上海'},
          {xVal: 30, yVal: -20, num: 17096869, name: '北京'},
          {xVal: 10, yVal: 5, num: 17096869, name: '深圳'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPointChart({
        options: this.seriesOption
      })
    }
    .height('50%')
  }
}
`

const columns = [
    {
        title: '名称',
        width: 180,
        dataIndex: 'name',
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color="#2db7f5">{!text ? '否' : '是'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];
const commonData = [
    {
        name: 'grid',
        describe: '直角坐标系内绘图网格',
        type: 'Object',
        defVal: '{}',
        state: '',
        remarks: '用于设置上下左右四个边距，替代历史的cPaddingL、cPaddingT、cPaddingR、cPaddingB四个属性，不过最新版本也会兼容旧的使用方式',
        children: [
            {
                name: 'left',
                describe: '图表内容区距离左侧位置',
                type: 'String | Number',
                defVal: '10%',
                remarks: '',
            },
            {
                name: 'right',
                describe: '图表内容区距离右侧位置',
                type: 'String | Number',
                defVal: '8%',
                remarks: '',
            },
            {
                name: 'top',
                describe: '图表内容区距离顶部位置',
                type: 'String | Number',
                defVal: '40',
                remarks: '',
            },
            {
                name: 'bottom',
                describe: '图表内容区距离底部位置',
                type: 'String | Number',
                defVal: '30',
                remarks: '',
            }
        ]
    },
    {
        name: 'color',
        describe: '调色盘颜色列表',
        type: 'String[]',
        defVal: "['#296DFF', '#ff5495fd', '#ff1acffd', '#ff72e4fd', '#7B72F7', '#F85758', '#FFBF29', '#D1E9F9', '#F5FAFC', '#5A657A']",
        remarks: '',
    },
    {
        name: 'title',
        describe: '标题组件与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        children: [
            {
                name: 'show',
                describe: '控制标题显示与隐藏',
                type: 'Boolean',
                defVal: 'true',
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                name: 'text',
                describe: '主标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'subtext',
                describe: '副标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'itemGap',
                describe: '主副标题之间的间距。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 69,
                name: 'left',
                describe: '标题左侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 70,
                name: 'right',
                describe: '标题右侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 71,
                name: 'top',
                describe: '标题顶部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 72,
                name: 'bottom',
                describe: '标题底部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 73,
                name: 'offset',
                describe: '标题偏移量',
                type: 'Array',
                defVal: '[0, -20]',
                state: '',
                remarks: '用于设置标题相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
            },
            {
                key: 2,
                name: 'textStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 21,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#333",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 22,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "18",
                        remarks: '',
                    },
                    {
                        key: 23,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 25,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 74,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 75,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            },
            {
                key: 3,
                name: 'subtextStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 31,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#aaa",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 32,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "12",
                        remarks: '',
                    },
                    {
                        key: 33,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 35,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 76,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 77,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            }
        ],
        remarks: '详细默认值请查看title属性讲解',
    },
    {
        name: 'legend',
        describe: '图例样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看legend属性讲解',
    },
    {
        name: 'tooltip',
        describe: '提示层样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看tooltip属性讲解',
    },
    {
        name: 'xAxis',
        describe: 'X轴样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看xAxis属性讲解',
    },
    {
        name: 'yAxis',
        describe: 'Y轴样式与功能配置',
        type: 'Object | Object[]',
        defVal: "{ ... }",
        state: '',
        remarks: '详细默认值请查看yAxis属性讲解，已支持多条y轴功能。',
    },
    {
        name: 'animation',
        describe: '是否开启动画。',
        type: 'Boolean',
        defVal: "true",
        state: '',
        remarks: '如果频繁更新数据建议将该属性设置为false',
    },
    {
        name: 'series',
        describe: '折线区域样式与功能配置',
        type: 'Object[]',
        defVal: "[ ... ]",
        remarks: '详细默认值请查看series属性讲解',
    }
];

const legendData = [
    {
        name: 'show',
        describe: '控制图例显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'left',
        describe: '图例距离左侧位置',
        type: 'String',
        defVal: '50%',
        remarks: '仅支持百分比字符串格式',
    },
    {
        name: 'top',
        describe: '图例距离顶部侧位置',
        type: 'String',
        defVal: '1%',
        remarks: '仅支持百分比字符串格式',
    },
    {
        name: 'itemGap',
        describe: '每项图例之间的间隔',
        type: 'Number',
        defVal: '10',
        remarks: '',
    },
    {
        name: 'itemTextGap',
        describe: '图形与文本的距离',
        type: 'Number',
        defVal: "5",
        remarks: '',
    },
    {
        name: 'itemWidth',
        describe: '图形的宽度',
        type: 'Number',
        defVal: "16",
        remarks: '',
    },
    {
        name: 'itemHeight',
        describe: '图形的高度',
        type: 'Number',
        defVal: "8",
        remarks: '',
    },
    {
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const tooltipData = [
    {
        name: 'show',
        describe: '控制提示层显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'type',
        describe: '提示层显示类型',
        type: 'String',
        defVal: 'default',
        remarks: '可选值：default（默认）、custom（自定义）。需要注意是自定义需要配合监控点击方法回调，通过回调信息自行显示内容与位置',
    },
    {
        name: 'backgroundColor',
        describe: '提示框背景颜色',
        type: 'String',
        defVal: 'rgba(50,50,50,0.7)',
        remarks: '',
    },
    {
        name: 'borderColor',
        describe: '提示框边框颜色',
        type: 'String',
        defVal: "#333",
        remarks: '',
    },
    {
        name: 'borderWidth',
        describe: '提示框边框宽度',
        type: 'Number',
        defVal: "0",
        remarks: '',
    },
    {
        name: 'padding',
        describe: '提示框内边距',
        type: 'Number',
        defVal: "10",
        remarks: '',
    },
    {
        key: 2,
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 21,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 22,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 23,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 25,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const xAxisData = [
    {
        key: 1,
        name: 'axisLine',
        describe: 'X轴线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 11,
                name: 'show',
                describe: '控制轴线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 12,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 121,
                        name: 'type',
                        describe: '线类型',
                        type: 'String',
                        defVal: "solid",
                        remarks: '可选值：solid（实线）',
                    },
                    {
                        key: 122,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 123,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 2,
        name: 'axisTick',
        describe: '刻度线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 21,
                name: 'show',
                describe: '控制刻度线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 22,
                name: 'interval',
                describe: '刻度线与文本的间隔',
                type: 'Number',
                defVal: "4",
                remarks: '',
            },
            {
                key: 23,
                name: 'length',
                describe: '刻度线的长度',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 24,
                name: 'lineStyle',
                describe: '刻度线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 242,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 243,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 3,
        name: 'axisLabel',
        describe: 'X轴文本标签样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 31,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 32,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 33,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 35,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const yAxisData = [
    {
        name: 'name',
        describe: 'Y轴名称',
        type: 'String',
        defVal: "空",
        remarks: '',
    },
    {
        key: 4,
        name: 'nameTextStyle',
        describe: 'Y轴名称样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 41,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 42,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 43,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 45,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    },
    {
        key: 1,
        name: 'axisLine',
        describe: 'Y轴线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 11,
                name: 'show',
                describe: '控制轴线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 12,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 121,
                        name: 'type',
                        describe: '线类型',
                        type: 'String',
                        defVal: "solid",
                        remarks: '可选值：solid（实线）',
                    },
                    {
                        key: 122,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 123,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 2,
        name: 'axisTick',
        describe: '刻度线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 21,
                name: 'show',
                describe: '控制刻度线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 22,
                name: 'interval',
                describe: '刻度线与文本的间隔',
                type: 'Number',
                defVal: "4",
                remarks: '',
            },
            {
                key: 23,
                name: 'length',
                describe: '刻度线的长度',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 24,
                name: 'lineStyle',
                describe: '刻度线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 242,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 243,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 3,
        name: 'axisLabel',
        describe: 'Y轴文本标签样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 31,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 32,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 33,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 35,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    },
    {
        key: 5,
        name: 'splitLine',
        describe: 'Y轴分割线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 51,
                name: 'show',
                describe: '控制分割线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 52,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 522,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 523,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        name: 'formatter',
        describe: '文本内容自定义函数',
        type: '(name) => {}',
        defVal: 'null',
        remarks: '回调函数返回当前文本内容，需要函数体return对应的值',
    }
];

const seriesData = [
    {
        name: 'name',
        describe: '系列名称，用于tooltip的显示，legend 的图例筛选',
        type: 'String',
        defVal: "空",
        remarks: '',
    },
    {
        name: 'color',
        describe: '系列颜色',
        type: 'String',
        defVal: "空",
        remarks: '',
    },
    {
        name: 'symbolSize',
        describe: '散点大小',
        type: 'Number | Function',
        defVal: "5",
        remarks: '可以传递回调函数，回调函数携带一个参数，参数值为当前散点的数据。计算结果记得return出来。',
    },
    {
        name: 'data',
        describe: '系列数据',
        type: '<Object>[]',
        defVal: '[]',
        must: true,
        remarks: '',
        key: 6,
        children: [
            {
                key: 60,
                name: 'xVal',
                describe: 'x轴坐标值',
                type: 'Number',
                defVal: "空",
                remarks: '',
            },
            {
                key: 61,
                name: 'yVal',
                describe: 'y轴坐标值',
                type: 'Number',
                defVal: "空",
                remarks: '',
            },
            {
                key: 62,
                name: 'num',
                describe: '实际散点值也可以与yVal一致',
                type: 'Number',
                defVal: "空",
                remarks: '',
            },
            {
                key: 63,
                name: 'name',
                describe: '散点对应名称',
                type: 'String',
                defVal: "空",
                remarks: '',
            }
        ]
    }
];



export {
    defCode,
    changeCode,
    xAxisCode,
    yAxisCode,
    legendCode,
    tooltipCode,
    seriesCode,
    columns,
    commonData,
    legendData,
    tooltipData,
    xAxisData,
    yAxisData,
    seriesData
}
